import React, { useEffect, useState } from "react";
import "./HeaderSite.css";
import 'bootstrap/dist/css/bootstrap.min.css';  
import { Button, Container, Offcanvas } from 'react-bootstrap';  
import { useHistory ,useLocation, useNavigate} from 'react-router-dom';
import RefreshClock from "./RefreshClock";
import { useCookies } from "react-cookie";

const HeaderSite = () => {
  
  const [cookies, setCookie] = useCookies(['access_token', 'hash_login']);
    const [show, setShow] = useState(false);  
    const closeSidebar = () => setShow(false);  
    const showSidebar = () => setShow(true);  
    localStorage.setItem("misTipos","CENTROS DE JUBILADOS,CAPS,COMISARIAS Y DESTACAMENTOS,CORREDORES,ESTACIONES,FISCALIAS,HOSPITALES,JARDINES,MUNICIPALES,PRIMARIAS,OFICINAS PUBLICAS,PLAZAS,Punto WIFI Conectados,SECUNDARIAS,UNIVERSIDADES");
    //localStorage.setItem("hashLogin", cookies.hash_login);
    useEffect(() => {
      const script = document.createElement('script');
    
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-NH5PL67HL1";
      script.async = true;
    
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments)}
      gtag('js', new Date());

      gtag('config', 'G-NH5PL67HL1');
      document.body.appendChild(script);
    
      return () => {
        document.body.removeChild(script);
      }
    }, []);
  

return (
  <>
                <header className="headerClass" align="center">
                  <RefreshClock/>
   <div className='p-1'>  
    <img className="imgIcon" src="./app_mimuni_logo.svg"/>
    <RefreshClock/>
    <img className="imgHamburg" onClick={showSidebar} src="./app_mimuni_iconohamburguesa.svg"/>
     
      <Offcanvas show={show} onHide={closeSidebar}>  
        <Offcanvas.Header closeButton>  
        </Offcanvas.Header>  

        <Offcanvas.Body>  
          
          <ul className="menu_responsive">
            <li className="separadores"><a href="/micuenta"><img src="/img/menu/menu_hamburguesa-16.png" className="icons_menu"></img>Mi Cuenta</a><br/></li>
            <li className="separadores"><a href="/"><img src="/img/menu/menu_hamburguesa-17.png" className="icons_menu icons_int"></img>Inicio</a><br/></li>
            <li><a href="/turnos"><img src="/img/menu/menu_hamburguesa-18.png" className="icons_menu icons_int"></img>Turnos</a><br/></li>
            {/*<li><a href="/emergencias"><img src="/img/menu/menu_hamburguesa-19.png" className="icons_menu icons_int"></img>Emergencias</a></li>*/}
            <li><a href="/credencial"><img src="/img/menu/menu_hamburguesa-20.png" className="icons_menu icons_int"></img>Credencial</a></li>
            <li><a href="/estudios"><img src="/img/menu/menu_hamburguesa-21.png" className="icons_menu icons_int"></img>Estudios médicos</a></li>
            <li><a href="/wifi"><img src="/img/menu/menu_hamburguesa-22.png" className="icons_menu icons_int"></img>Mapa Muni</a></li>
            {/*<li><a href="/agenda"><img src="/img/menu/menu_hamburguesa-23.png" className="icons_menu icons_int"></img>Agenda</a></li>*/}
            {/*<li><a href="/telemedicina"><img src="/img/menu/menu_hamburguesa-24.png" className="icons_menu icons_int"></img>Telemedicina</a></li>*/}
            {/*<li><a href="/beneficios"><img src="/img/menu/menu_hamburguesa-25.png" className="icons_menu icons_int"></img>Beneficios</a></li>*/}
            <li><a href="/estacionamientoppal"><img src="/img/menu/menu_hamburguesa-26.png" className="icons_menu icons_int"></img>Estacionamiento</a></li>
            <li><a href="/actividades"><img src="/img/menu/menu_hamburguesa-27.png" className="icons_menu icons_int"></img>Clubes Municipales</a></li>
            {/*<li><a href="/medicina"><img src="/img/menu/menu_hamburguesa-28.png" className="icons_menu icons_int"></img>Medicina preventiva</a></li>*/}
            {/*<li className="separadores" ><a href="#"><img src="/img/menu/menu_hamburguesa-30.png" className="icons_menu icons_int"></img>Billetera Digital</a></li>*/}
            <li className="separadores"><a href="/chat"><img src="/img/menu/app_mimuni_iconochat.svg" className="icons_menu icons_int"></img>Chat MiMuni</a></li>
            <li><a href="/?logout=true"><img src="/img/menu/menu_hamburguesa-31.png" className="icons_menu icons_int"></img>Salir</a></li>
           <li></li>
           <li></li>
           <li className="tiny_text">v2.11</li>

          </ul>


        </Offcanvas.Body>  
      </Offcanvas>  
      </div>  
     
    </header>
    
    </>
    );
}

export default HeaderSite;